// extracted by mini-css-extract-plugin
export default {"key-value-container":"XN5DMD"};